export const TOKENS_KEY = '__token__'
export const AUTH_PROVIDER_KEY = '__auth_provider__'
export const INITIAL_TOKENS = {
  accessToken: '',
  refreshToken: '',
}
